
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 2500 1800"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h2500v1800H0","fill":"#003897"}}),_c('path',{attrs:{"d":"M700 0h400v1800H700M0 700h2500v400H0","fill":"#fff"}}),_c('path',{attrs:{"d":"M800 0h200v1800H800M0 800h2500v200H0","fill":"#d72828"}})])
          )
        }
      }
    